import authAxios from '../auth/auth-axios';

export default class ActivationCodeService {
  static async activate(activationCode) {
    const axios = await authAxios();
    await axios.post(`/credit/activate`, {
      activationCode,
    });
  }
}
